(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligFacilityDialogController', ProgEligFacilityDialogController);

    ProgEligFacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgEligFacility'];

    function ProgEligFacilityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgEligFacility) {
        var vm = this;

        vm.progEligFacility = entity;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};
        vm.openCalendar = openCalendar;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progEligFacility.id !== null) {
                ProgEligFacility.update(vm.progEligFacility, onSaveSuccess, onSaveError);
            } else {
                ProgEligFacility.save(vm.progEligFacility, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:progEligFacilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.progEligFacility.startDate;
        }

        function validateStartDate(){
            vm.startDateOptions.maxDate = vm.progEligFacility.endDate;
        }
    }
})();
